import { DetailBookingDTO } from 'entities/bookings/model/dtoTypes'
import { DetailBooking } from 'entities/bookings/model'
import { adaptAdBookingInfoDTO } from 'entities/areas/model/adapters/adaptAdBookingInfoDTO'

export const adaptDetailBookingDto = (
    source: DetailBookingDTO,
): DetailBooking => ({
    id: source.id,
    comment: source.comment,
    endTime: new Date(source.end_time),
    startTime: new Date(source.start_time),
    expireTime: source.expire_time ? new Date(source.expire_time) : null,
    areaPrice: parseFloat(source.area_price),
    totalPrice: parseFloat(source.total_price),
    totalPriceWithDiscount: parseFloat(source.total_price_with_discount),
    areaPercentDiscount: parseFloat(source.area_percent_discount),
    areaAbsolutDiscount: parseFloat(source.area_absolut_discount),
    areaId: source.area.id ?? null,
    areaName: source.area.name ?? null,
    areaAdBookingInfo: source.area?.ad_booking_info
        ? adaptAdBookingInfoDTO(source.area.ad_booking_info)
        : null,
    nomenclatures:
        source?.nomenclatures?.map(nomenclature => ({
            id: nomenclature.id,
            name: nomenclature.name,
            code: nomenclature.code,
            price: parseFloat(nomenclature.price),
            absolutDiscount: parseFloat(nomenclature.absolut_discount),
            count: nomenclature.count,
        })) ?? [],
    counterparty: {
        id: source.counterparty.id,
        fullName: source.counterparty.full_name,
        phone: parseInt(source.counterparty.phone),
        type: source.counterparty.type,
    },
    orderId: source.order_id,
    createdAt: new Date(source.created_at),
})
